<div class="an-select" #anSelect>
  <!-- readonly -->
  <div
    class="an-select--selected"
    #inputElement
    [style.height]="input_height + 'rem'"
    [style.width]="input_width + 'rem'"
    [ngClass]="{
      'border--error': hasError,
      'border-empty': !haveValue(),
      'border-selected': haveValue(),
      'border-disabled': is_disabled,
      'border-none': withoutBorder
    }"
    (click)="selectDropdown_toggle(); onTouchCallback()"
  >
    <div *ngIf="valuesSelected_get_first()" class="an-select--selected--text font--xxl-13">
      <div class="an-select--selected--text--first font--xxl-13 wrap--1-line">
        {{ valuesSelected_get_first() }}
      </div>
      <div *ngIf="valuesSelected_get_sum()" class="an-select--selected--text--sum font--xxl-13">
        +({{ valuesSelected_get_sum() }})
      </div>
    </div>
    <div *ngIf="!valuesSelected_get_first()" class="an-select--selected--placeholder">
      <div class="an-select--selected--text--first wrap--1-line font--xxl-13 text-center color-dark-blue">
        {{ valuePlaceholder }}
      </div>
    </div>
    <div class="an-select--selected--drop" [ngClass]="{ expanded: selectDropdown_show }"></div>
  </div>
  <div
    *ngIf="selectDropdown_show"
    #selectDropdown
    class="an-select--dropdown an-select--dropdown"
    [ngStyle]="{ bottom: open_top ? input_height + 'rem' : 'unset', top: !open_top ? input_height + 'rem' : 'unset' }"
  >
    <div *ngIf="filter_field" class="an-select--dropdown--search" style="padding: 0 0.5rem">
      <input
        type="text"
        class="font--xxl-13"
        #inputFilterElement
        placeholder="Search..."
        (keyup)="dropdownItem_filter($event)"
        autocomplete="off"
      />
    </div>
    <div class="an-select--dropdown--content">
      <div *ngIf="use_key_value">
        <div
          *ngFor="let dropdownItem of dropdownList_copy"
          class="an-select--dropdown--content--option cursor-pointer"
          [ngClass]="{ 'background-stroke font-weight--500': dropdownItem_selected(dropdownItem[objectKey]) }"
          (click)="dropdownItem_select(dropdownItem[objectKey], $event)"
        >
          <div *ngIf="with_checkbox" class="an-select--checkbox">
            <img
              *ngIf="dropdownItem_selected(dropdownItem[objectKey])"
              src="/assets/images/icons/checkbox_active.svg"
              alt=""
            />
          </div>
          <label class="checkbox margin-xxl--left-20 margin-xxl--right-20">
            <input type="checkbox" [checked]="dropdownItem_selected(dropdownItem[objectKey])" />
            <span class="checkbox--checkmark checkbox--checkmark--red-middle"></span>
            <span
              class="checkbox--text wrap--1-line font--xxl-13 color-body-text"
              [ngClass]="{ 'font-regular color-dark-blue': dropdownItem_selected(dropdownItem[objectKey]) }"
              >{{ dropdownItem[objectValue] }}</span
            >
          </label>
        </div>
      </div>
      <div *ngIf="!use_key_value">
        <div
          *ngFor="let dropdownItem of dropdownList_copy"
          class="an-select--dropdown--content--option cursor-pointer"
          (click)="dropdownItem_select(dropdownItem, $event)"
        >
          <div *ngIf="with_checkbox" class="an-select--checkbox">
            <img *ngIf="dropdownItem_selected(dropdownItem)" src="/assets/images/icons/checkbox_active.svg" alt="" />
          </div>
          <label class="checkbox margin-xxl--left-20 margin-xxl--right-20">
            <input type="checkbox" [checked]="dropdownItem_selected(dropdownItem)" />
            <span class="checkbox--checkmark checkbox--checkmark--red-middle"></span>
            <span
              class="checkbox--text wrap--1-line font--xxl-13 color-body-text"
              [ngClass]="{ 'font-regular color-dark-blue': dropdownItem_selected(dropdownItem) }"
            >
              {{ dropdownItem }}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
